import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ScheduleModal",
  props: {
    shouldDisplay: {
      type: Boolean,
      default: false
    }
  },
  setup() {}
});